import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.data.qbooks.statics.taxType', {
    taxExclusive: 'Tax exclusive',
    taxInclusive: 'Tax inclusive',
    noTax: 'No tax',
});
